import { AvailableLocales } from '../../../app.state';
import { BaseController } from '../../../common/base/controller';

class LanguageSwitcherController extends BaseController {
  constructor(controllerService, $scope) {
    'ngInject';
    super({ controllerService, $scope });
  }

  $onInit() {
    // Initialize footer lang links
    this.updateLangLinks();

    // Listen to language changes to update the language links
    this.appService.subscribe('setLang', this.$scope, (event, lang) => {
      this.updateLangLinks(lang);
    });
  }

  setLang(lang) {
    // Set new provided language
    this.appService.setLang(lang);
    this.updateLangLinks(lang);
  }

  updateLangLinks(lang) {
    // Use current language by default
    if (!lang) {
      lang = this.$translate.use();
    }
    // Show lang links except for current language
    this.languages = AvailableLocales.filter((l) => l !== lang);
  }
}

export default LanguageSwitcherController;
